<template>
  <div id="fellow" class="application-section">
    <section id="fellowSection" class="container is-fluid">
      <div>
        <div>
          Fellowship of the RCPharm is awarded to Members that have made an outstanding original
          contribution to the advancement of pharmaceutical knowledge, or attained distinction in the science, practice,
          profession or history of pharmacy.
        </div><br />
        <div>
          <ul>
            <li>
              Only Members of the Society can nominate someone for a Fellowship,
              and must have their nomination supported by two further Members.
            </li>
            <li>One of the nominees must also be a Fellow.</li>
            <li>Nominations should be confidential.</li>
            <li>Once awarded, the title of Fellow is valid for life (provided the individual remains a member of RCPharm).</li>
          </ul>
        </div><br />
        <div>
          <a href="/rps-membership/fellows">You can find more information and download the Fellow nomination form here.</a><br /><br />
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import '@/styles/application.scss';

export default {
  name: 'Fellow',
};
</script>
